import { DefaultCountry } from '../types/default.country';

export const defaultCountries: DefaultCountry[] = [
  {
    value: 'FR',
  },
  {
    value: 'CH',
  },
  {
    value: 'NL',
  },
  {
    value: 'CA',
  },
  {
    value: 'US',
  },
  {
    value: 'CO',
  },
  {
    value: 'DK',
  },
  {
    value: 'AU',
  },
  {
    value: 'MU',
  },
  {
    value: 'IT',
  },
  {
    value: 'UK',
  },
  {
    value: 'FI',
  },
  {
    value: 'NO',
  },
  {
    value: 'SE',
  },
  {
    value: 'ES',
  },
  {
    value: 'CL',
  },
  {
    value: 'GR',
  },
  {
    value: 'DE',
  },
  {
    value: 'PL',
  },
  {
    value: 'MX',
  },
];
